<div class="avatar-container" [style.background-image]="'url(' + src + ')'"></div>
